import {
    DISPATCH_APPROVAL_REQUEST,
    DISPATCH_APPROVAL_SUCCESS,
    DISPATCH_APPROVAL_FAILED,
} from "app/redux/actions/Dispatch/constant";

const INIT_STATE = {
    loading: false,
    totalPage: 0,
    data: [],
    error: {
        isError: false,
        message: null,
    },
};

export const dispatchApprovalReducer = function (state = INIT_STATE, action) {
    switch (action?.type) {
        case DISPATCH_APPROVAL_REQUEST:
            return {
                loading: true,
                totalPage: 0,
                data: [],
                error: {
                    isError: false,
                    message: null,
                },
            };
        case DISPATCH_APPROVAL_SUCCESS:
            return {
                loading: false,
                data: action?.payload?.data,
                totalPage: action?.payload?.totalPage,
                error: {
                    isError: false,
                    message: null,
                },
            };
        case DISPATCH_APPROVAL_FAILED:
            const { isError = true, message = "Something Went Wrong" } =
                action?.payload?.error || {};
            return {
                loading: false,
                totalPage: 0,
                data: [],
                error: {
                    isError: isError,
                    message: message,
                },
            };
        default:
            return state;
    }
};
